import type { ReactNode } from "react"
import { Reveal } from "@/components/reveal"

/** Oversized ordinal used as a compositional element, the Swiss way. */
function Ordinal({ children }: { children: string }) {
  return (
    <span className="t-display block leading-none text-accent/15" aria-hidden="true">
      {children}
    </span>
  )
}

export function SectionHead({
  id,
  index,
  title,
  lead,
}: {
  id: string
  index: string
  title: string
  lead?: ReactNode
}) {
  return (
    <Reveal className="grid12" as="header">
      <span
        className="reveal-rule col-span-12 mb-4 block h-[3px] bg-foreground"
        aria-hidden="true"
        data-nico-rule
      />
      <div className="reveal col-span-4 md:col-span-2">
        <Ordinal>{index}</Ordinal>
      </div>
      <div className="col-span-12 md:col-span-9 md:col-start-3">
        <h2 id={`${id}-heading`} className="reveal-clip t-lg text-balance text-foreground">
          {title}
        </h2>
        {lead && (
          <p
            className="reveal t-body mt-3 max-w-[52ch] text-muted-foreground"
            style={{ ["--d" as string]: "100ms" }}
          >
            {lead}
          </p>
        )}
      </div>
    </Reveal>
  )
}
